import styled from 'styled-components';
import { cutTextByLinesCount } from '@hotelplan/components.common.mixins';
import { BsLink } from '@hotelplan/core.basis.bs-link';
import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';

export const BookmarkCardImg = styled.div<{ overlay?: boolean }>(
  ({ overlay = true }) =>
    sx2CssThemeFn({
      position: 'relative',
      justifyContent: 'center',
      cursor: 'pointer',
      display: 'inline-flex',
      width: '100%',
      overflow: 'hidden',
      img: {
        width: '100%',
        height: '100%',
        objectFit: `cover`,
        aspectRatio: '76 / 63',
      },
      '.wishlist-icon': {
        position: 'absolute',
        right: '16px',
        top: '16px',
        width: '26px',
        height: '26px',
        color: 'white',
        cursor: 'pointer',
        fill: 'transparent',
      },
      ...(overlay && {
        ':before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundImage:
            'linear-gradient(-180deg, rgba(0, 0, 0, 0) 45%, rgba(0, 0, 0, 0.6) 100%)',
          zIndex: 1,
        },
      }),
    })
);

export const BookmarkItemB2BLeadText = styled.div(
  sx2CssThemeFn({
    mt: 3,
    ...cutTextByLinesCount(3),
    '.breadcrumb-section + &': {
      mt: 0,
    },
  })
);

export const BookmarkItemLeadText = styled(BookmarkItemB2BLeadText)(
  sx2CssThemeFn({
    mt: [3, 3],
  })
);

export const FdrBookmarkBreadcrumbSectionWrapper = styled.div(
  sx2CssThemeFn({
    mt: '10px',
    mb: '10px',
  })
);

export const DisruptersWrap = styled.div(({ theme: { space } }) => ({
  position: 'absolute',
  top: space[3],
  left: space[3],
}));

export const BookmarkSectionContentWrapper = styled.div(
  sx2CssThemeFn({
    display: 'grid',
    gridTemplateColumns: ['1fr', '1fr 1fr 1fr'],
    '@media screen and (min-width: 768px) and (max-width: 1024px) and (orientation: portrait)':
      {
        gridTemplateColumns: '1fr 1fr',
      },
    '@media screen and (max-width: 896px) and (orientation: landscape)': {
      gridTemplateColumns: '1fr 1fr',
    },
    gap: ['28px', '20px'],
    mt: ['24px', '28px'],
    mb: ['24px', '28px'],
    pb: '28px',
    borderBottom: `1px solid`,
    '> a': {
      display: 'flex',
    },
    ':last-child': {
      borderBottom: 'none',
    },
    '.button-text': {
      display: 'none',
    },
  })
);

export const BookmarkItemHeaderB2CWrapper = styled.div(
  sx2CssThemeFn({
    px: 3,
    pb: [3, 3],
    color: 'white',
    position: 'absolute',
    bottom: 0,
    width: '100%',
    zIndex: 1,
  })
);

export const BookmarkItemHeader = styled.div(
  sx2CssThemeFn({
    '.card-title': {
      fontSize: [3, '22px'],
      '.chevron-icon': {
        ml: '10px',
      },
    },
  })
);

export const BookmarkItemB2BContentWrapper = styled.div({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'flex-end',
});

export const BookmarkItemB2BContent = styled.div({
  flexGrow: 1,
});

export const BookmarkItemB2BIcon = styled.div(({ theme: { colors } }) => ({
  flexShrink: 0,
  color: colors.primary,
  height: '24px',
}));

export const BookmarkSectionHeader = styled.div(
  ({ theme: { text, card } }) => ({
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    '.title': text.groupHeading,
    '.total-count': card.cardSectionTotalCount,
  }),
  ({ theme: { card } }) => card.cardsSectionHeader
);

export const BookmarkSectionHeaderLoading = styled(BookmarkSectionHeader)(
  sx2CssThemeFn({
    mt: '100px',
  })
);

export const BookmarkItemLink = styled(BsLink)({
  position: 'relative',
  height: '100%',
  width: '100%',
  img: {
    transition: 'all 0.5s ease',
  },
  '.chevron-icon': {
    marginRight: '10px',
    transition: 'all 0.5s ease',
  },
  '&:hover': {
    img: {
      transform: 'scale(1.1)',
    },
    color: 'black',
    '.chevron-icon': {
      transform: 'translateX(10px)',
    },
  },
});
